import BuyboxExp5 from './index';
import type { SnowplowClickoutContext, SnowplowContext } from '@/helpers/tracking/providers/snowplow-contexts';
import { BuyBoxFilterOptions } from './utils';
import { OfferPresentationType } from '@/interfaces/titles';

const property = 'buybox' as const;

export const buyboxExp5TrackImpression = () => BuyboxExp5.trackEvent({ action: 'impression', property });

export const buyboxExp5TrackClickout = (contexts: SnowplowClickoutContext[]) =>
	BuyboxExp5.trackEvent({
		action: 'click',
		label: 'clickout',
		property,
		contexts,
	});

export const buyboxExp5TrackMoreInfoModalClick = (contexts: SnowplowClickoutContext[]) =>
	BuyboxExp5.trackEvent({
		action: 'click',
		label: 'more_info_clicked',
		property,
		contexts,
	});

export const buyboxExp5TrackFreeTrialClickout = (contexts: SnowplowClickoutContext[]) =>
	BuyboxExp5.trackEvent({
		action: 'click',
		label: 'free_trial_clickout',
		property,
		contexts,
	});

export const buyboxExp5TrackNotifyMeClick = (contexts: SnowplowContext[]) =>
	BuyboxExp5.trackEvent({
		action: 'click',
		label: 'notify_me_clicked',
		property,
		contexts,
	});

export const buyboxExp5TrackBuyBoxFilterClick = (
	contexts: SnowplowContext[],
	label: BuyBoxFilterOptions | OfferPresentationType | null
) =>
	BuyboxExp5.trackEvent({
		action: 'click',
		label: `filter_${label ? label?.toLowerCase() : 'best'}`,
		property,
		contexts,
	});
